<template>
    <div class="posts__products-overview" :class="{ 'posts__products-overview--loading' : $store.state.loading }">
        <template class="posts__row" v-for="(category, index) in categories">
            <template v-if="categoryHasProducts(category.name)">
                <div class="flexible-section" :id="'category-' + category.name.toLowerCase().replace(/\s+/g, '-')">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-10 offset-lg-1">
                                <div class="row">
                                    <div class="col-12">
                                        <h2 class="posts__category-title" v-if="category.name"
                                            v-html="category.name"></h2>
                                    </div>
                                    <div class="col-12 posts__row-desc">
                                        <div class="posts__category-desc">
                                            <p v-if="category.description"
                                               v-html="category.description">
                                            </p>
                                            <div class="posts__category-buttons" v-if="category.buttons">
                                                <template v-for="button in category.buttons">
                                                    <template v-if="button.link">
                                                        <a :href="button.link.url"
                                                           class="button"
                                                           :class="buttonType(button.color)"
                                                           v-text="button.link.title"></a>
                                                    </template>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <template v-for="type in types">
                                    <template v-if="typeHasProducts(type.name, category.name)">
                                        <h4 class="posts__type-name" v-html="type.name"></h4>
                                        <div class="row gx-4 gx-lg-5 post-cards" :id="'type-' + category.name.toLowerCase().replace(/\s+/g, '-') + '-' + type.name.toLowerCase().replace(/\s+/g, '-')">
                                            <template v-for="post in ids_posts">
                                                <template
                                                    v-if="showByCatAndType(post.product_category[0], post.product_type[0], category.name, type.name)">
                                                    <post-card v-bind:post="post"></post-card>
                                                </template>
                                            </template>
                                            <div class="col-lg-6" v-if="advisorCard.content">
                                                <a :href="advisorCard.link" v-if="['Readers', 'Cameras', 'Camera\'s'].includes(type.name)"
                                                   class="post-cards__advisory">
                                                    <div v-html="advisorCard.content"></div>
                                                    <img v-if="advisorCard.image.length > 5" :src="advisorCard.image" :alt="advisorCard.title" width="372" height="110">
                                                    <div class="post-cards__advisory--arrow">
                                                        <svg width="17" height="14" viewBox="0 0 17 14" fill="none"
                                                             xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M1.00195 5.7143C0.449668 5.7143 0.00195316 6.16201 0.00195317 6.71431C0.00195317 7.26659 0.449668 7.71431 1.00195 7.71431L1.00195 5.7143ZM15.002 6.71431L15.7384 7.39086L16.36 6.71431L15.7384 6.03775L15.002 6.71431ZM10.4884 0.323448C10.1147 -0.0832487 9.48209 -0.110037 9.07539 0.263615C8.6687 0.637264 8.64191 1.26986 9.01556 1.67656L10.4884 0.323448ZM9.01556 11.752C8.64191 12.1587 8.6687 12.7913 9.07539 13.165C9.48209 13.5386 10.1147 13.5118 10.4884 13.1051L9.01556 11.752ZM1.00195 7.71431L15.002 7.71431L15.002 5.7143L1.00195 5.7143L1.00195 7.71431ZM15.7384 6.03775L10.4884 0.323448L9.01556 1.67656L14.2656 7.39086L15.7384 6.03775ZM14.2656 6.03775L9.01556 11.752L10.4884 13.1051L15.7384 7.39086L14.2656 6.03775Z"
                                                                fill="white"></path>
                                                        </svg>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
import {ref} from 'vue';
import PostCard from "./PostCard.vue";
import axios from "axios";

export default {
    setup() {
        const advisorCard = ref({
            content: window.location.href.includes('nl') ? '<h4>Product Keuzehulp</h4>' : '<h4>Product advisory</h4>',
            link: '',
            image: '',
        });

        return {
            advisorCard
        }
    },
    props: {
        ids_posts: {
            type: Array
        }
    },
    data() {
        return {
            categories: [],
            types: []
        }
    },
    components: {
        'post-card': PostCard,
    },
    methods: {
        categoryHasProducts(categoryName) {
            let productCount = 0;
            this.ids_posts.forEach((post, index) => {
                if (post.product_category[0] === categoryName) {
                    productCount++
                }
            });
            return productCount > 0;
        },
        typeHasProducts(typeName, categoryName) {
            let productCount = 0;
            this.ids_posts.forEach((post, index) => {
                if (post.product_type[0] === typeName && post.product_category[0] === categoryName) {
                    productCount++
                }
            });
            return productCount > 0;
        },
        showByCatAndType(postCategory, postType, rowCategory, rowType) {
            if (postCategory === rowCategory && postType === rowType) {
                return true;
            }
        },
        getAllProductTypeTerms() {
            // FIRST
            // Get all product_types terms, we need this to create separate section for each category.
            let _this = this;

            let fetchUrl = this.$store.state.baseUrl;
            fetchUrl += '/wp-json/wp/v2/product_type';

            return axios.get(fetchUrl)
                .then(response => {
                    response.data.forEach((type) => {
                        let rowObject = {
                            name: type.name,
                            order: type.acf.type_order - 1,
                            items: []
                        }

                        _this.types[rowObject.order] = rowObject;
                        // _this.types.push(rowObject);
                    });
                })
                .catch(e => {
                });
        },
        getAllProductCatTerms() {
            // SECOND
            // Get all product_category terms, we need this to create separate section for each category.
            let _this = this;

            let fetchUrl = this.$store.state.baseUrl;
            fetchUrl += '/wp-json/wp/v2/product_category';

            return axios.get(fetchUrl)
                .then(response => {

                    response.data.forEach((category) => {
                        let rowObject = {
                            name: category.name,
                            description: category.description,
                            buttons: category.acf.buttons,
                            order: category.acf.category_order - 1
                        }

                        this.categories[rowObject.order] = rowObject;
                        // _this.categories.push(rowObject);
                    });
                })
                .catch(e => {
                });
        },
        buttonType(type) {
            return type;
        },
        retrieveCardContent() {
            let lang = this.getLanguageByUrl();
            let apiUrl = window.location.origin + '/wp-json/nedapids/v1/product-advisor/card?lang=' + lang;

            fetch(apiUrl, {})
                .then((response) => response.json())
                .then((data) => {
                    this.advisorCard.content = data.content;
                    this.advisorCard.link = data.link;
                    this.advisorCard.image = data.image;
                });
        },
        getLanguageByUrl() {
            if (window.location.href.includes('/nl/')) {
                return 'nl';
            }
            return 'en';
        }
    },
    created() {
        this.getAllProductTypeTerms();
        this.getAllProductCatTerms();
        this.retrieveCardContent();
    }
}
</script>
